module.exports = "/_next/static/images/CriticalLifeCOVER_Website-Banner-9078b10fa156623162a095a8fc21ce0c.jpg";